export class TokenRefreshCancelledError extends Error {
  constructor() {
    super("Token refresh cancelled");
    this.name = "TokenRefreshCancelledError";
  }
}
